import { render, staticRenderFns } from "./PhysicianProfile.vue?vue&type=template&id=6a9f4727&scoped=true"
import script from "./PhysicianProfile.vue?vue&type=script&lang=js"
export * from "./PhysicianProfile.vue?vue&type=script&lang=js"
import style0 from "./PhysicianProfile.vue?vue&type=style&index=0&id=6a9f4727&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9f4727",
  null
  
)

export default component.exports